/* eslint-disable react/no-danger */
import React from 'react';

import { useHandleGenerator } from '../../contexts/RoutesContext';
import { useTreesReady } from '../../contexts/PagesContext';

import PageMeta from '../partials/PageMeta';
import EmptyButton from '../buttons/Empty';
import PlaySquareIcon from '../icons/PlaySquare';

import styles from '../../../styles/pages/home.module.scss';

const propTypes = {};

const defaultProps = {};

const HomePage = () => {
    const handle = useHandleGenerator();
    const treesReady = useTreesReady();

    const innerStyle = {
        opacity: treesReady ? 1 : 0,
    };

    return (
        <div className={styles.container}>
            <PageMeta />
            <div className={styles.inner} style={innerStyle}>
                <div className={styles.column}>
                    <EmptyButton className={styles.button} href={handle('country')}>
                        <PlaySquareIcon className={styles.play} />
                    </EmptyButton>
                </div>
            </div>
        </div>
    );
};
HomePage.propTypes = propTypes;
HomePage.defaultProps = defaultProps;

export default HomePage;
